import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}
interface CustomerInterface {
    customerid: string;
    location?: string;
    name?: string;
    platform_fees? : string
}

const CustomerAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([
        {
            location: "",
            name: "",
            platform_fees: ""
        }
    ])
    const [input, setInput] = useState<CustomerInterface>(
        {
            customerid: "",
            location: "",
            name: "",
            platform_fees: ""
        }
    )

    useEffect(() => {
        if (type=="edit" && id) {
            getData(id)
        }
    }, [])


    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    
    function getData(id:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/customer/${id}`).then(res => {
            setLoading(false)
            console.log(12, res)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        })
    }
    

    function handleSubmit() {
        if (type=="add") {
            console.log("add", input)

            if (input.name == "") {
                return alert("Name is required")
            }
            if (input.location == "") {
                return alert("location is required")
            }

            setLoading(true)
            axiosInstance.post("https://api.cl-ds.com/internal/operations/v1/customer/", input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        } else {
            console.log("edit", input)

            if (input.name == "") {
                return alert("Name is required")
            }

            setLoading(true)
            axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/customer/${id}/`, input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>,field: string, index?:number ) {
        console.log("handleChange", inputs)
        if (index!=null) {
            let newArr = [...inputs]
            newArr[index] = {
                ...newArr[index],
                [field]: e.target.value
            }
    
            setInputs(newArr)
        } else {
            setInput(prev => ({
                ...prev,
                [field]: e.target.value
            }))
        }
    }

    function addInput() {
        setInputs(prev => [...prev , {
            location: "",
            name: "",
            platform_fees: ""
        }])
    }

    
    function removeInput(index:number) {
        let newArr = inputs.filter( (input, i) => i != index)

        setInputs(newArr)
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}


            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link  to={`/customer`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Customer</h5>

                    {type == "add" && 
                        <div style={{border:"1px dashed gray", padding: "1rem", borderRadius: 10, marginBottom:"1rem"}}>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Name</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Location</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.location} onChange={(e)=>handleChange(e, "location")}/>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Platform Fees</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" value={input.platform_fees} onChange={(e)=>handleChange(e, "platform_fees")}/>
                                </div>
                            </div>
                        </div>
                    }

                    {type == "edit" && 
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Name</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Customer ID</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.customerid} disabled/>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Location</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.location} onChange={(e)=>handleChange(e, "location")}/>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Platform Fees</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" value={input.platform_fees} onChange={(e)=>handleChange(e, "platform_fees")}/>
                            </div>
                        </div>
                        </>
                    }
                    
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default CustomerAddEdit